<template>
  <v-layout 
    justify-center
    class="secondary">
    <v-btn text
      icon
      class="modal-cta"
      @click="changeSelectedImage('First')">
      <v-icon>fas fa-angle-double-left</v-icon>
    </v-btn>
    <v-btn text
      icon
      class="modal-cta"
      @click="changeSelectedImage('Previous')">
      <v-icon>fas fa-angle-left</v-icon>
    </v-btn>
    <v-btn text
      icon
      class="modal-cta"
      @click="changeSelectedImage('Next')">
      <v-icon>fas fa-angle-right</v-icon>
    </v-btn>
    <v-btn text
      icon
      class="modal-cta"
      @click="changeSelectedImage('Last')">
      <v-icon>fas fa-angle-double-right</v-icon>
    </v-btn>
    <v-btn text
      icon
      class="modal-cta"
      @click="swapSelectedImages()">
      <v-icon>fas fa-sync</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: "stereoBrowserToolbar",
  methods: {
    changeSelectedImage(button) {
      this.$store.dispatch("changeSelectedStereoPair", button);
    },
    swapSelectedImages() {
      this.$store.dispatch("swapSelectedStereoPair");
    }
  }
};
</script>

<style lang="scss" scoped>
.examList {
  position: absolute;
  left: 20px;
}

.checkbox {
  position: absolute;
  left: 15px;
  bottom: -5px;
}

.multiviewToolbar {
  margin-left: 45px;
}

.v-input--slider {
  width: 300px;
  margin-top: 18px;
}

</style>
